import React, {useEffect} from 'react';
import ActionRequiredGrid from '../../../features/dealer/action-required-grid/components/ActionRequiredGrid';
import {useTitle} from "../../../contexts/title";

export default function ActionRequiredPage() {
    const pageTitle = useTitle();

    useEffect(() => {
        pageTitle.setTitle('Action Required Items');
    }, [pageTitle])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <ActionRequiredGrid />
            </div>
        </React.Fragment>
    )
} 
